import { getToken } from "../auth/tokenAuth";
import doRequest from "../helpers";

export const requestGetAcadReinforceTypes = async () => {
	const [result, err] = await doRequest(
		"/TipoRefuerzo",
		"GET",
		null,
		getToken()
	);
	if (err) return null;
	const { data } = result;
	if (data?.state !== 1) return null;
	return data.data.listTipoRefuerzo.map(
		({
			idTipoRefuerzo: id,
			nombre: name,
			icono: icon,
			descripcion: description,
		}) => {
			return {
				id,
				name,
				icon,
				description,
			};
		}
	);
};
export const requestGetAcadReinforcePeriod = async () => {
	const [result, err] = await doRequest(
		"/PeriodoRefuerzoAcademico",
		"GET",
		null,
		getToken()
	);
	if (err) return null;
	const { data } = result;
	if (data?.state !== 1) return null;
	return data.data.periodo;
};
export const requestGetEnvironmentTypeList = async () => {
	const [result, err] = await doRequest(
		"/RefuerzoAcademico/ListarTipoInstalacionPS",
		"GET",
		null,
		getToken()
	);
	if (err) return null;
	const { data } = result;
	if (data?.state !== 1) return null;
	return data.data.tipoInstalacion.map(
		({ codInstalacion: id, nombre: name }) => {
			return { id, name };
		}
	);
};
export const requestGetEnvironmentList = async ({
	campusId,
	environmentTypeId,
	date,
	time,
	quantityVacancy,
}) => {
	const [result, err] = await doRequest(
		"/RefuerzoAcademico/DisponibilidadInstalacion",
		"POST",
		{
			idCampusDetalle: campusId,
			tipoInstalacion: environmentTypeId,
			fecha: date,
			horaInicio: time.start,
			horaFin: time.end,
			vacantes: quantityVacancy,
		},
		getToken()
	);
	if (err) return null;
	const { data } = result;
	if (data?.state !== 1) return null;
	return data.data.instalacionDisponible.map(
		({
			codigoAmbiente,
			tipoInstalacion,
			idInstalacion,
			direccion,
			piso,
			capacidad,
		}) => {
			return {
				id: idInstalacion,
				environmentCode: codigoAmbiente,
				environmentType: tipoInstalacion,
				address: direccion,
				floor: piso,
				capacity: capacidad,
			};
		}
	);
};
